import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { gamesService } from "../../services/Games/GamesService";
import { appStore } from "../../stores/appStore";
import InfoMessages from "../InfoMessage/InfoMessage";
import Loader from "../ui-components/Loader";
import { StyledLiveFullTime, StyledLiveHead, StyledLiveTimer } from "./LiveStyle";
import { B2BResize } from "../../services/common/globalFunctions";

const Live = () => {
  const [liveWeekGames, setLiveWeekGames] = useState([]);
  const [gameTimer, setGameTimer] = useState(0);
  const [showLoader, setShowLoader] = useState(false);

  const { t } = useTranslation("General");

  // getting and setting data in appStore
  const {
    currentLeague,
    currentSeason,
    liveWeekNumber,
    goalScored,
    countDownTimer,
    leagueName
  } = appStore((state) => ({
    currentLeague: state.currentLeague,
    currentSeason: state.currentSeason,
    liveWeekNumber: state.liveWeekNumber,
    goalScored: state.goalScored,
    countDownTimer: state.countDownTimer,
    leagueName: state.leagueName
  }));

  // game goal score blinking animation
  useEffect(() => {
    goalScored.removeAnimation = false;
    setLiveWeekGames((prevLiveWeekGames) => {
      let index = null;
      const tempLiveWeekGames = [...prevLiveWeekGames];
      tempLiveWeekGames.forEach((game, gameIdx) => {
        if (game._id === goalScored._id) {
          index = gameIdx;
        }
      });
      if (index != null) {
        goalScored.prevHomeGoals = tempLiveWeekGames[index].homeTeamGoals;
        goalScored.prevAwayGoals = tempLiveWeekGames[index].awayTeamGoals;
      }
      tempLiveWeekGames[index] = goalScored;
      return tempLiveWeekGames;
    });

    clearAnimation(goalScored);
  }, [goalScored]);

  // game goal score animation clear
  const clearAnimation = (game) => {
    let intRef = setTimeout(() => {
      game.removeAnimation = true;
      clearTimeout(intRef);
    }, 700);
  };
  const leagueDisplayName = leagueName && leagueName?.leaguePrefix ? leagueName?.leaguePrefix + currentLeague?.leagueName?.split("-")[1] : currentLeague?.leagueName;

  // timmer counter (2min completing in 90sec)
  useEffect(() => {
    // 0.75 for 120
    // 1.5 for 90
    //let currentGameTime = 90 - Math.floor(countDownTimer * 1.5);
    //setGameTimer(Math.abs(currentGameTime));

    let liveGameTime = 0;
    if (+countDownTimer <= 30) {
      liveGameTime = 90;
    } else {
      liveGameTime = 120 - +countDownTimer; //Math.floor(countDownTimer * 1.5);
    }
    liveGameTime = Math.abs(liveGameTime);
    setGameTimer(liveGameTime);

    // setLiveGameTimer((prevTime) => {
    //   // console.log(countDownTimer);
    //   let liveGameTime = 90;
    //   if (countDownTimer <= 30) {
    //     liveGameTime = 90;
    //   } else {
    //     liveGameTime = 120 - +countDownTimer; //Math.floor(countDownTimer * 1.5);
    //   }
    //   console.log(liveGameTime);
    //   return Math.abs(liveGameTime);
    // });
  }, [countDownTimer]);

  // useEffect(() => {
  //   const matchCountdown = setInterval(() => {
  //     if (liveGameTimer < 1) {
  //       setGameTimer(0);
  //     } else {
  //       let currentGameTime = 90 - Math.floor(liveGameTimer * 1.5);
  //       if (gameTimer >= 90) {
  //         setGameTimer(90);
  //       } else if (gameTimer < currentGameTime) {
  //         setGameTimer((prevTime) => prevTime + 1);
  //       }
  //     }
  //   }, 475);
  //   return () => clearInterval(matchCountdown);
  // }, [liveGameTimer, gameTimer]);

  // fetching data from server
  useEffect(() => {
    setShowLoader(true);
    const getLiveWeekGames = async () => {
      const response = await gamesService.getLiveWeekGames(
        currentLeague.leagueId,
        currentSeason,
        liveWeekNumber
      );
      let data = response.data;
      data.forEach((game) => {
        game.prevHomeGoals = 0;
        game.prevAwayGoals = 0;
      });
      if (data.length > 0) {
        setShowLoader(false);
        setLiveWeekGames(data);
        setTimeout(() => {
          B2BResize("Live Page");
        }, 500);
      }
    };
    getLiveWeekGames();
  }, [currentLeague, currentSeason, liveWeekNumber]);

  return showLoader ? (
    <Loader />
  ) : (
    <React.Fragment>
      <div className="live-table w-100 pt-2">
        <StyledLiveHead className="m-0 p-2 bg-primary text-white d-flex justify-content-around justify-items-center align-items-center">
          <div className="flex-fill text-start ms-2">
            {gameTimer < 90 && (
              <span className="fw-bold text-dark bg-warning align-items-center table-liveicon me-1">
                {t("LIVE")}
              </span>
            )}
            <span>
              {t(`${leagueDisplayName}`)} {t("Season")} #{currentSeason}, {t("Week")}{" "}
              <span>
                {liveWeekNumber === 0 ? liveWeekNumber + 1 : liveWeekNumber}
              </span>
            </span>
          </div>
          <div className="text-end me-2">
            {gameTimer >= 90 ? (
              <React.Fragment>
              {/* <div className="fw-bold fs-5">
                <StyledLiveFullTime className="me-1 text-white">{t("F")}</StyledLiveFullTime>
                <StyledLiveFullTime className="ms-1 text-white">{t("T")}</StyledLiveFullTime>
              </div> */}
              </React.Fragment>
            ) : (
              <div>
                <StyledLiveTimer className="bg-secondary fw-bold text-center d-inline-block live-timmer me-1">
                  {gameTimer < 10 && gameTimer >= 0
                    ? "0" + gameTimer
                    : gameTimer}
                </StyledLiveTimer>
                {t("Min")}
              </div>
            )}
          </div>
        </StyledLiveHead>
        {liveWeekNumber <= 0 ? (
          <InfoMessages messages={<div>{t("No Matches Currently Live.")}</div>} />
        ) : (
          <div className="height-100 text-dark">
            {liveWeekGames.map((liveGame, index) => (
              <div
                className="d-flex justify-content-center p-2 border-bottom border-0 align-items-center"
                key={index}
              >
                <div className="w-50 text-end pe-2 d-flex justify-content-end align-items-center text-truncate">
                  <div className="w-100 text-end text-truncate">
                    <strong className="pe-2">
                      {t(`${liveGame.homeTeam.teamName}`)}
                    </strong>
                  </div>
                  <img
                    width={"24px"}
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/teams/" + liveGame?.leagueRef + "/" +
                      liveGame.homeTeam.teamImageURL
                    }
                    alt=""
                  />
                </div>
                <div className="d-flex justify-content-center align-items-center border border-light py-1 rounded bg-light">
                  <div
                    className={"text-center h3 m-0 mx-1 rounded-3 live-score"}
                  >
                    {liveGame.homeTeamGoals &&
                      liveGame.homeTeamGoals !== liveGame.prevHomeGoals &&
                      !liveGame.removeAnimation ? (
                      <span className="scrore-Animation">
                        {liveGame.homeTeamGoals || 0}
                      </span>
                    ) : (
                      <span>{liveGame.homeTeamGoals || 0}</span>
                    )}
                  </div>
                  <b className="fw-bold text-center">:</b>
                  <div
                    className={
                      liveGame.awayTeamGoals &&
                        liveGame.awayTeamGoals !== liveGame.prevAwayGoals &&
                        !liveGame.removeAnimation
                        ? "text-center h3 m-0 mx-1 live-score rounded-3 scrore-Animation"
                        : "text-center h3 m-0 mx-1 live-score rounded-3"
                    }
                  >
                    {liveGame.awayTeamGoals || 0}
                  </div>
                </div>
                <div className="w-50 text-end ps-2 d-flex justify-content-end align-items-center text-truncate">
                  <img
                    width={"24px"}
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/teams/" + liveGame?.leagueRef + "/" +
                      liveGame.awayTeam.teamImageURL
                    }
                    alt=""
                  />
                  <div className="w-100 text-start text-truncate">
                    {" "}
                    <strong className="ps-2">
                      {t(`${liveGame.awayTeam.teamName}`)}
                    </strong>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
export default Live;
